import Vue from "vue";
import WaveLoader from "@/components/PulseInsights/WaveLoader.vue";
import { getPulseTrackTheme } from "@/components/PulseInsights/pulseTracks";
export default Vue.extend({
    name: "PulseQuestions",
    components: { WaveLoader },
    data() {
        return {
            loading: true,
            submitting: false,
            completing: false,
            // the full ordered run from get-progress (every track, back-to-back)
            questions: [],
            currentIndex: 0,
            selectedValue: null,
            errorMessage: "",
            resultsMessage: "Thanks for answering the questions,\nwe're just gathering the results for you.",
        };
    },
    computed: {
        question() {
            return this.questions[this.currentIndex] || null;
        },
        isLast() {
            return (this.questions.length > 0 &&
                this.currentIndex === this.questions.length - 1);
        },
        trackTitle() {
            const current = this.question;
            if (!current)
                return "";
            const landing = this.$store.getters.pulseLanding;
            const tracks = landing && Array.isArray(landing.tracks) ? landing.tracks : [];
            const match = tracks.find((track) => track.track_slug === current.track_slug);
            return match
                ? match.title
                : getPulseTrackTheme(current.track_slug).defaultTitle;
        },
        progressPercent() {
            const current = this.question;
            if (!current || !current.total_questions)
                return 0;
            return Math.min(100, Math.round((current.question_number / current.total_questions) * 100));
        },
    },
    mounted() {
        this.loadProgress();
    },
    methods: {
        async loadProgress() {
            this.loading = true;
            const res = await this.api({
                path: "api/u/pulse/get-progress",
                noop: true,
            });
            if (res && Array.isArray(res.questions) && res.questions.length) {
                this.questions = res.questions;
                // resume.question_number is the 1-based position of the first
                // unanswered question; a fresh (or completed) run resumes at Q1
                const resumeNumber = res.resume && res.resume.question_number
                    ? res.resume.question_number
                    : 1;
                this.currentIndex = Math.min(Math.max(resumeNumber - 1, 0), this.questions.length - 1);
                this.syncSelection();
            }
            this.loading = false;
        },
        // pre-select whatever answer is already stored for the current question
        syncSelection() {
            const current = this.questions[this.currentIndex];
            this.selectedValue =
                current && current.data && current.data.answer
                    ? current.data.answer
                    : null;
        },
        async submitAnswer() {
            if (!this.selectedValue || !this.question)
                return;
            this.submitting = true;
            this.errorMessage = "";
            const current = this.question;
            const res = await this.api({
                path: "api/u/pulse/answer-question",
                track_slug: current.track_slug,
                question_id: current.question_id,
                answer: this.selectedValue,
            });
            this.submitting = false;
            if (!res || res.success === false) {
                this.errorMessage =
                    (res && res.err) || "Something went wrong, please try again.";
                return;
            }
            // reflect the answer locally so back/forward re-selects it
            current.data = { answer: this.selectedValue };
            current.answered = true;
            if (!res.next_question) {
                // null => the whole check-in is complete and finalized server-side
                this.finish();
                return;
            }
            this.goToNext(res.next_question);
        },
        goToNext(next) {
            // the run is fixed, so the returned next_question already exists in our
            // ordered list — jump to it; fall back to a plain step if not found
            const index = this.questions.findIndex((q) => q.question_id === next.question_id &&
                q.track_slug === next.track_slug);
            if (index !== -1) {
                this.currentIndex = index;
            }
            else if (this.currentIndex < this.questions.length - 1) {
                this.currentIndex += 1;
            }
            else {
                this.questions.push(next);
                this.currentIndex = this.questions.length - 1;
            }
            this.errorMessage = "";
            this.syncSelection();
        },
        previous() {
            if (this.currentIndex <= 0)
                return;
            this.errorMessage = "";
            this.currentIndex -= 1;
            this.syncSelection();
        },
        finish() {
            // Show the loader during the transition; the report screen fetches
            // get-report (and get-trends) on mount.
            this.completing = true;
            this.$router.push("/personal/insights/report").catch(() => { });
        },
    },
});
